export function randomCoverImage() {
  const random = Math.floor(Math.random() * defaultCoverImageList.length);
  return defaultCoverImageList[random].categoryCoverImg;
}

export const defaultWidth = 1040;
export const defaultHeight = 282;

export const defaultCoverImageList: {
  categoryCoverImg: string;
}[] = [
  {
    categoryCoverImg: 'event_cover_image/event_ctg_meeting01.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_meeting02.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_examination01.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_examination02.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_seminar01.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_seminar02.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_event01.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_event02.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_1on101.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_1on102.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_regularity01.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_regularity02.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_evaluation01.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_evaluation02.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_others01.jpg',
  },
  {
    categoryCoverImg: 'event_cover_image/event_ctg_others02.jpg',
  },
];
